// extracted by mini-css-extract-plugin
module.exports = {"noDataContainer":"NoData_noDataContainer__2RGYr","noDataHeader":"NoData_noDataHeader__2RaAs","noDataText":"NoData_noDataText__jJRoD","noDataImg":"NoData_noDataImg__9a5eG"};